// Stylesheets
import 'palt-typesetting/dist/typesetter.css';
import './assets/scss/site.scss';

import { observePaltTypesetting, paltTypesetting } from './assets/modules/paltTypesetting.js';
import { hover } from './assets/modules/hover';
import { copyUrl } from './assets/modules/copyUrl';
import { externalLink } from './assets/modules/externalLink';
import { fluidEmbed } from './assets/modules/fluidEmbed';
import { popup } from './assets/modules/popup.js';
import { popupURL } from './assets/modules/popupURL';
import { accordion } from './assets/modules/accordion';
import { formSelect } from './assets/modules/form.js';
import { Newsletter } from './assets/modules/newsletter.js';
import { trigger } from './assets/modules/trigger';
import { initPhotoSwipeFromDOM } from './assets/modules/photoswipe';
import { scrollOpacityFade } from './assets/modules/scrollOpacityFade.js';
import { stickySidebar } from './assets/modules/stickySidebar';
import { search }  from './assets/modules/search';
import { marquee } from './assets/modules/marquee.js';
import { carousel } from './assets/modules/carousel.js';
import { pickupCarousel } from './assets/modules/pickupCarousel.js';
import { belt } from './assets/modules/belt.js';
import { chaos } from './assets/modules/chaos.js';
import { bounceImage } from './assets/modules/bounceImage.js';
import { headerLogoScroll } from './assets/modules/headerLogoScroll.js';
import { infoTriangle } from './assets/modules/infoTriangle.js';
import { clockNumber } from './assets/modules/clockNumber.js';
import { fiftyInterviewsBanner } from './assets/modules/fiftyInterviewsBanner.js';
import { richHeroMedia } from './assets/modules/richHeroMedia.js';
import { richHeroHeader } from './assets/modules/richHeroHeader.js';
import { topAd } from './assets/modules/topAd.js';

window.popeyeV4PaltTypesetting = paltTypesetting;

const init = () => {
  paltTypesetting();
  observePaltTypesetting();
  hover();
  copyUrl();
  externalLink();
  fluidEmbed();
  popup();
  popupURL();
  accordion();
  formSelect();
  Newsletter();
  trigger();
  initPhotoSwipeFromDOM();
  scrollOpacityFade();
  stickySidebar();
  search();
  marquee();
  carousel();
  pickupCarousel();
  belt();
  chaos();
  bounceImage();
  headerLogoScroll();
  infoTriangle();
  clockNumber();
  fiftyInterviewsBanner();
  richHeroMedia();
  topAd();
  richHeroHeader();
  document.body.classList.add('is-init');
}

init();
